import { HecoTestAddresses, HecoTestTokens } from "./address/hecotest";
import { EthereumAddresses, EthereumTokens } from "./address/ethereum";
import { ShastaAddresses, ShastaTokens } from "./address/shasta";
import { TronAddresses, TronTokens } from "./address/tron";
import { RopstenAddresses, RopstenTokens } from "./address/ropsten";
import { HecoAddresses, HecoTokens } from "./address/heco";
import { CrabTestAddresses, CrabTestTokens } from "./address/crabtest";
import { CrabAddresses, CrabTokens } from "./address/crab";
import { MumbaiAddresses, MumbaiTokens } from "./address/mumbai";
import { PolygonAddresses, PolygonTokens } from "./address/polygon";
export var LandId;
(function (LandId) {
    LandId[LandId["ETHEREUM"] = 1] = "ETHEREUM";
    LandId[LandId["TRON"] = 2] = "TRON";
    LandId[LandId["CRAB"] = 3] = "CRAB";
    LandId[LandId["HECO"] = 4] = "HECO";
    LandId[LandId["POLYGON"] = 5] = "POLYGON";
    LandId[LandId["_ETHEREUM"] = 1001] = "_ETHEREUM";
    LandId[LandId["_TRON"] = 1002] = "_TRON";
    LandId[LandId["_CRAB"] = 1003] = "_CRAB";
    LandId[LandId["_HECO"] = 1004] = "_HECO";
    LandId[LandId["_POLYGON"] = 1005] = "_POLYGON";
})(LandId || (LandId = {}));
export const CONFIG = {
    [LandId.ETHEREUM]: {
        address: EthereumAddresses,
        tokens: EthereumTokens,
    },
    [LandId.TRON]: {
        address: TronAddresses,
        tokens: TronTokens,
    },
    [LandId.CRAB]: {
        address: CrabAddresses,
        tokens: CrabTokens,
    },
    [LandId.HECO]: {
        address: HecoAddresses,
        tokens: HecoTokens,
    },
    [LandId.POLYGON]: {
        address: PolygonAddresses,
        tokens: PolygonTokens,
    },
    [LandId._ETHEREUM]: {
        address: RopstenAddresses,
        tokens: RopstenTokens,
    },
    [LandId._TRON]: {
        address: ShastaAddresses,
        tokens: ShastaTokens,
    },
    [LandId._CRAB]: {
        address: CrabTestAddresses,
        tokens: CrabTestTokens,
    },
    [LandId._HECO]: {
        address: HecoTestAddresses,
        tokens: HecoTestTokens,
    },
    [LandId._POLYGON]: {
        address: MumbaiAddresses,
        tokens: MumbaiTokens,
    },
};
